<template>
<el-drawer title="编辑" :visible.sync="visible" size="30%" :append-to-body="true" :wrapperClosable="false">
    <div class="hs-container">
        <el-form :model="form" label-width="100px" label-position="left" style="margin-top:12px;">
            <el-form-item label="名称">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="活动区域">
                <el-input v-model="form.region"></el-input>
            </el-form-item>
            <el-form-item label="活动形式">
                <el-input v-model="form.type"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit">确认添加</el-button>
                <el-button @click="visible = false">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</el-drawer>
</template>

<script>
const form = {
    category_id: 0,
    order_id: 0,
    remark: ''
};
export default {
    components: {

    },
    props: {
        parent: {}
    },
    data() {
        return {
            visible: false,
            detailsData: [],
            options: {},
            type: "",
            form: Object.assign({}, form),
        }
    },
    beforeCreate() {

    },
    methods: {
        showDrawer(row, type) {
            let _this = this;
            _this.visible = true;
            if (type == 'edit') {
                let params = {
                    id: row.id
                };
                this.dialog.title = '编辑公司品牌';
                this.dialog.type = type;
                let url = '/api/dictionary.company/read';
                this.$post(url, params).then((res) => {
                    if (res.code == 200) {
                        this.form = res.data.row;
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            }
        },
        submit(){
            
        }
    }
}
</script>
